<header class="topbar">
  <div class="location">
    <span class="location__context min-[960px]:pl-3 pl-10">Portal Financiadores</span>
    <mat-icon>chevron_right</mat-icon>
    <strong>{{ pageTitle() }}</strong>
  </div>

  <div class="topbar__actions">
    <button class="icon-button notification-button" type="button" aria-label="Abrir notificaciones" (click)="goToNotifications()">
      <mat-icon>notifications_none</mat-icon>
      <span class="notification-dot" aria-hidden="true"></span>
    </button>

    <button class="avatar" type="button" (click)="goToProfile()" [attr.aria-label]="'Ir al perfil de ' + username()">
      {{ avatarLabel() }}
    </button>
  </div>
</header>
